import { render, staticRenderFns } from "./HeaderSortArrow.vue?vue&type=template&id=39530a6b&"
import script from "./HeaderSortArrow.vue?vue&type=script&lang=js&"
export * from "./HeaderSortArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports